import React from "react";
import { STREAM_OPTIONS_TAB_LABEL } from "./EditCameraUtils/editCameraGeneralInfoLayout";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { handleTabChangeEditCamera } from "./EditCameraUtils/handleTabChangeEditCamera";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export const EditCameraTabs = ({
  clickedTab,
  setClickedTab,
  editMode,
  setActiveTab,
  siteInfo,
  cameraGeneralInfo,
  setCameraGeneralInfo,
  setPatchObject,
  setGeneralInfoChangesMade,
  immixAlertsOnCamera,
  diceAlertsOnCamera,
  sureViewAlertsOnCamera,
  immixAlerts,
  diceAlerts,
  setActiveChangeMade,
  sureviewAlerts,
  setAddImmixAlertDialogOpen,
  setAddDiceAlertDialogOpen,
  setAddSureviewAlertDialogOpen,
  streamsObject,
  setActiveProducts,
  activeProducts,
  axisCamera,
  recipientsConfiguredData,
  titlesArray,
  navigate,
  setBackdropLoadingScreenOn,
  setRecipientsConfiguredData,
  setTitlesArray,
  actionRulesData,
  setActionRulesData,
  actionRulesTitlesArray,
  setActionRulesTitlesArray,
  applicationsConfiguredData,
  mobotixCamera,
  timeTablesData,
  setTimeTablesData,
  iPNotifyData,
  setIPNotifyData,
  actionHandlerData,
  setActionHandlerData,
  axisFinished,
  setSendingImmixTest,
  setImmixTestSuccessDialogOpen,
  setImmixTestFailDialogOpen,
  setSendingDiceTest,
  setDiceTestSuccessDialogOpen,
  setDiceTestFailDialogOpen,
  cameraWebhookData,
  setCameraWebhooksPatchObject,
  setCameraWebhooksChangesMade,
  productsData,
  setProductsData,
  allTabsOpen,
  setAllTabsOpen,
  setBackupProductsData,
  sentinelAlertsOnCamera,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlertsOnCamera,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  patriotAlertsOnCamera,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  uSMonitoringAlertsOnCamera,
  uSMonitoringAlerts,
  setAddUSMonitoringAlertDialogOpen,
  webhooksAlertsOnCamera,
  softguardAlertsOnCamera,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  evalinkAlertsOnCamera,
  showStreamParameters,
  streamParametersData,
  streamParametersPatchObject,
  setStreamParametersPatchObject,
  setStreamParametersChangesMade,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  setDeleteImmixAlertDialogOpen,
  setDeleteDiceAlertDialogOpen,
}: {
  clickedTab: any;
  setClickedTab: any;
  editMode: any;
  setActiveTab: any;
  siteInfo: any;
  cameraGeneralInfo: any;
  setCameraGeneralInfo: any;
  setPatchObject: any;
  setGeneralInfoChangesMade: any;
  immixAlertsOnCamera: boolean;
  diceAlertsOnCamera: boolean;
  sureViewAlertsOnCamera: boolean;
  immixAlerts: any;
  diceAlerts: any;
  setActiveChangeMade: any;
  sureviewAlerts: any;
  setAddImmixAlertDialogOpen: any;
  setAddDiceAlertDialogOpen: any;
  setAddSureviewAlertDialogOpen: any;
  streamsObject: any;
  setActiveProducts: any;
  activeProducts: any;
  axisCamera: boolean;
  recipientsConfiguredData: any;
  titlesArray: any;
  navigate: NavigateFunction;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setRecipientsConfiguredData: any;
  setTitlesArray: any;
  actionRulesData: any;
  setActionRulesData: Dispatcher<any>;
  actionRulesTitlesArray: any;
  setActionRulesTitlesArray: Dispatcher<any>;
  applicationsConfiguredData: any;
  mobotixCamera: boolean;
  timeTablesData: any;
  setTimeTablesData: Dispatcher<any>;
  iPNotifyData: any;
  setIPNotifyData: any;
  actionHandlerData: any;
  setActionHandlerData: any;
  axisFinished: any;
  setSendingImmixTest: Dispatcher<boolean>;
  setImmixTestSuccessDialogOpen: Dispatcher<boolean>;
  setImmixTestFailDialogOpen: Dispatcher<boolean>;
  setSendingDiceTest: Dispatcher<boolean>;
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>;
  setDiceTestFailDialogOpen: Dispatcher<boolean>;
  cameraWebhookData: any;
  setCameraWebhooksPatchObject: any;
  setCameraWebhooksChangesMade: Dispatcher<boolean>;
  productsData: any;
  setProductsData: Dispatcher<any>;
  allTabsOpen: boolean;
  setAllTabsOpen: Dispatcher<boolean>;
  setBackupProductsData: any;
  sentinelAlertsOnCamera: boolean;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlertsOnCamera: boolean;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: Dispatcher<boolean>;
  patriotAlertsOnCamera: boolean;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>;
  uSMonitoringAlertsOnCamera: boolean;
  uSMonitoringAlerts: any;
  setAddUSMonitoringAlertDialogOpen: Dispatcher<boolean>;
  webhooksAlertsOnCamera: boolean;
  softguardAlertsOnCamera: boolean;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: Dispatcher<boolean>;
  evalinkAlertsOnCamera: boolean;
  showStreamParameters: boolean;
  streamParametersData: any;
  streamParametersPatchObject: any;
  setStreamParametersPatchObject: any;
  setStreamParametersChangesMade: Dispatcher<boolean>;
  setAddStreamWebhookDialogOpen: Dispatcher<boolean>;
  setEditStreamWebhookDialogOpen: Dispatcher<boolean>;
  setDeleteImmixAlertDialogOpen: Dispatcher<boolean>;
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>;
}) => {
  const { flags } = useFeatureFlag();
  const showProductsTabAutopatrolCameras =
    flags.showProductsTabAutopatrolCameras;

  const showSlicingTab = flags.showSlicingTab;
  const showVlmTab = flags.showVlmTab;

  const { sysaidAlertsOnCamera, vCHOnlySite } = useEditCameraStore();
  const showAlertSettingsTab =
    (immixAlertsOnCamera ||
      diceAlertsOnCamera ||
      sureViewAlertsOnCamera ||
      cameraWebhookData ||
      siteInfo.webhooks ||
      webhooksAlertsOnCamera ||
      sentinelAlertsOnCamera ||
      boldAlertsOnCamera ||
      patriotAlertsOnCamera ||
      softguardAlertsOnCamera ||
      sysaidAlertsOnCamera ||
      evalinkAlertsOnCamera) &&
    siteInfo.integration_type_name !== "autopatrol";

  // TODO: REMOVE - Temporary debug logs for Products tab visibility
  const showProductsTab =
    siteInfo.integration_type_name !== "autopatrol" ||
    (siteInfo.integration_type_name === "autopatrol" &&
      showProductsTabAutopatrolCameras &&
      !vCHOnlySite);
  return (
    <Box sx={{ width: "100%" }}>
      <ThemeProvider theme={theme}>
        <Tabs
          value={clickedTab}
          onChange={(event, tabValue) =>
            handleTabChangeEditCamera(
              tabValue,
              editMode,
              setClickedTab,
              setActiveTab,
              siteInfo,
              cameraGeneralInfo,
              setCameraGeneralInfo,
              setPatchObject,
              setGeneralInfoChangesMade,
              immixAlerts,
              diceAlerts,
              setActiveChangeMade,
              sureviewAlerts,
              setAddImmixAlertDialogOpen,
              setAddDiceAlertDialogOpen,
              setAddSureviewAlertDialogOpen,
              streamsObject,
              activeProducts,
              recipientsConfiguredData,
              titlesArray,
              navigate,
              setBackdropLoadingScreenOn,
              setRecipientsConfiguredData,
              setTitlesArray,
              actionRulesData,
              setActionRulesData,
              actionRulesTitlesArray,
              setActionRulesTitlesArray,
              applicationsConfiguredData,
              timeTablesData,
              setTimeTablesData,
              iPNotifyData,
              setIPNotifyData,
              actionHandlerData,
              setActionHandlerData,
              axisFinished,
              setSendingImmixTest,
              setImmixTestSuccessDialogOpen,
              setImmixTestFailDialogOpen,
              setSendingDiceTest,
              setDiceTestSuccessDialogOpen,
              setDiceTestFailDialogOpen,
              cameraWebhookData,
              setCameraWebhooksPatchObject,
              setCameraWebhooksChangesMade,
              productsData,
              setProductsData,
              allTabsOpen,
              setAllTabsOpen,
              setBackupProductsData,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              boldAlerts,
              setAddBoldAlertDialogOpen,
              patriotAlerts,
              setAddPatriotAlertDialogOpen,
              uSMonitoringAlerts,
              setAddUSMonitoringAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              streamParametersData,
              streamParametersPatchObject,
              setStreamParametersPatchObject,
              setStreamParametersChangesMade,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              setDeleteImmixAlertDialogOpen,
              setDeleteDiceAlertDialogOpen,
              immixAlertsOnCamera,
              diceAlertsOnCamera,
              sureViewAlertsOnCamera,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera
            )
          }
          aria-label="tabs"
          color="primary"
        >
          <Tab
            value="one"
            label="General Info"
            sx={{ fontFamily: "Mulish", fontWeight: "Bold", color: "primary" }}
          />
          {/* <Tab
            value="two"
            label="Connection"
            sx={{ fontFamily: "Mulish", fontWeight: "Bold", color: "primary" }}
          /> */}
          {showStreamParameters && (
            <Tab
              value="fifteen"
              label={STREAM_OPTIONS_TAB_LABEL}
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
          {/* <Tab
            value="three"
            label="Notifications"
            sx={{
              fontFamily: "Mulish",
              fontWeight: "Bold",
              color: "primary",
            }}
          /> */}
          {(siteInfo.integration_type_name !== "autopatrol" ||
            (siteInfo.integration_type_name === "autopatrol" &&
              showProductsTabAutopatrolCameras &&
              !vCHOnlySite)) && (
            <Tab
              value="four"
              label="Products"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
          {showProductsTab && showSlicingTab && (
            <Tab
              value="five"
              label="Slicing"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
          {showVlmTab && (
            <Tab
              value="seventeen"
              label="VLM"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
          {showAlertSettingsTab && (
            <Tab
              value="sixteen"
              label="Alert Settings"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
          {axisCamera && (
            <Tab
              value="seven"
              label="Axis Settings"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
          {mobotixCamera && (
            <Tab
              value="eight"
              label="Mobotix Settings"
              sx={{
                fontFamily: "Mulish",
                fontWeight: "Bold",
                color: "primary",
              }}
            />
          )}
        </Tabs>
      </ThemeProvider>
    </Box>
  );
};
